const DEVMODE_STORAGE_KEY = 'WHISPER_CORE_DEV';
export const setDevMode = enabled => {
  try {
    if (enabled) {
      localStorage.setItem(DEVMODE_STORAGE_KEY, 'true');
    } else {
      localStorage.removeItem(DEVMODE_STORAGE_KEY);
    }
  } catch (e) {
    // Do nothing
  }
};
export const isDevMode = () => {
  try {
    return localStorage.getItem(DEVMODE_STORAGE_KEY) === 'true';
  } catch (e) {
    return false;
  }
};